import { useDispatch as useReactReduxDispatch } from 'react-redux'

import * as devStore from './configureStore.dev'
import * as prodStore from './configureStore.prod'

const storeConfig = import.meta.env.MODE === 'production' ? prodStore : devStore

export const { store, persistor } = storeConfig

type AppDispatch = typeof store.dispatch
export const useDispatch = useReactReduxDispatch.withTypes<AppDispatch>()
